import {
  SVG,
  UserTierTypes,
  formatNumber,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';

import {Text, View} from 'native-base';
import SevenStarsTextLogo from 'assets/seven_stars_text_logo.svg';

import React from 'react';
import {useTheme} from 'styled-components/native';

export interface NextTierCreditsProps {
  currentLevel: UserTierTypes;
  remainingCreditForNextLevel: number;
  nextTier?: string;
  isGiftedTier: boolean;
}

const NextTierCredits: React.FC<NextTierCreditsProps> = props => {
  const {currentLevel, remainingCreditForNextLevel, nextTier, isGiftedTier} =
    props;

  const isSevenStars = currentLevel === UserTierTypes.SEVEN_STARS;
  const theme = useTheme();
  const {white, shuttleGray} = theme.colors;
  const isDesktop = useIsDesktop();

  if (isSevenStars) {
    if (isDesktop) {
      return (
        <View flexDirection="column" alignItems="center" paddingX="32px">
          <Text
            fontFamily="heading"
            fontWeight="bold"
            fontSize="18px"
            lineHeight="22px"
            color={white}
            marginBottom="8px">
            {formatNumber(remainingCreditForNextLevel)}
          </Text>
          <Text
            fontFamily="body"
            fontWeight="semibold"
            fontSize="12px"
            lineHeight="20px"
            color={white}
            textAlign="center">
            Tier Credits to your next Seven
          </Text>
          <Text
            fontFamily="body"
            fontWeight="semibold"
            fontSize="12px"
            lineHeight="20px"
            color={white}
            textAlign="center"
            marginBottom="24px">
            Stars Experience Credit
          </Text>
          <SVG
            height={22}
            width={94}
            source={SevenStarsTextLogo}
            alt="Seven Stars text logo"
          />
        </View>
      );
    }

    return (
      <View flexDirection="column">
        <View flexDirection="row" justifyContent="end">
          <Text
            fontFamily="body"
            fontSize="11px"
            fontWeight="bold"
            color={shuttleGray}>
            {formatNumber(remainingCreditForNextLevel)}{' '}
          </Text>
          <Text fontFamily="body" fontSize="11px" color={shuttleGray}>
            Tier Credits to your next
          </Text>
        </View>
        <Text
          fontFamily="body"
          fontSize="11px"
          color={shuttleGray}
          textAlign="end">
          Seven Stars Experience Credit
        </Text>
      </View>
    );
  }

  return (
    <View flexDirection="row">
      <Text
        fontFamily="body"
        fontSize={isDesktop ? '14px' : '11px'}
        fontWeight="bold"
        color={shuttleGray}>
        {formatNumber(remainingCreditForNextLevel)}{' '}
      </Text>
      <Text
        fontFamily="body"
        fontSize={isDesktop ? '14px' : '11px'}
        color={shuttleGray}>
        to {isGiftedTier && 'maintain '}
        {nextTier}
      </Text>
    </View>
  );
};

export default NextTierCredits;
